import React from 'react';
import _isNil from 'lodash/isNil';
import { getPlayerComponent, getVideoPlayerProps } from './VideoPlayer.utils';
import DefaultPlayer from './components/DefaultPlayer';
import VimeoPlayer from './components/VimeoPlayer';
import YoutubePlayer from './components/YoutubePlayer';
import { EMBED_SOURCE_DEFAULT_TYPE, IN_VIEWPORT_LOAD_STRATEGY } from '../../../foundation/components/Embed/Embed.constants';
import { EmbedAspectRatioPropType, EmbedLoadStrategyPropType, EmbedSourcePropType } from '../../../foundation/components/Embed/Embed.types';
var defaultProps = {
  url: '',
  videoId: '',
  source: EMBED_SOURCE_DEFAULT_TYPE,
  aspectRatio: null,
  placeholder: '',
  autoplay: true,
  controls: false,
  loop: true,
  mute: true,
  className: '',
  loadStrategy: IN_VIEWPORT_LOAD_STRATEGY,
  icon: ''
};
export var playerComponents = {
  vimeo: VimeoPlayer,
  youtube: YoutubePlayer,
  "default": DefaultPlayer
};
export default function VideoPlayer(props) {
  if (_isNil(props)) {
    return null;
  }
  var videoPlayerProps = getVideoPlayerProps(props);
  if (_isNil(videoPlayerProps)) {
    return null;
  }
  var resolvedSource = videoPlayerProps.source;
  var PlayerComponent = getPlayerComponent(resolvedSource, playerComponents);
  return /*#__PURE__*/React.createElement(PlayerComponent, videoPlayerProps);
}
VideoPlayer.defaultProps = defaultProps;